export { Fade } from './Fade';
